export const DAO_CODE = 'DEAL' + '_LOSS' + '_MOTIVE' + '_DAO';
